// @ts-nocheck

class PDPEstimatedDateManager {
  constructor() {
    this.deliveryContainer = document.querySelector('.pdp-estimated-delivery');
    this.preorderContainer = document.querySelector('.pdp-expected-sale-date');
    this.deliveryDays = 5;
    
    this.init();
  }

  init() {
    this.updateDeliveryDate();
    
    this.initializeFromCurrentVariant();

    document.addEventListener('variant:change', (event) => {
      this.handleVariantChange(event);
    });
  }

  /**
   * Legge i dati della variante corrente dal DOM
   */
  initializeFromCurrentVariant() {
    const wrapper = document.querySelector('.pdp-estimated-delivery-wrapper');
    if (!wrapper) return;

    const stock = parseInt(wrapper.dataset.stock ?? 0);
    const hasEverStock = wrapper.dataset.hasEverStock === 'true';
    const isPreorder = wrapper.dataset.isPreorder === 'true';
    const inventoryPolicy = wrapper.dataset.inventoryPolicy ?? 'deny';
    const expectedSaleDate = wrapper.dataset.expectedSaleDate;

    const allowPreorder = stock <= 0 && hasEverStock != true && isPreorder && inventoryPolicy === 'continue';

    this.updateContainers(stock, allowPreorder, expectedSaleDate);
  }

  /**
   * @param {CustomEvent} event - L'evento variant:change
   */
  handleVariantChange(event) {
    const variantId = event.detail?.variantId;
    if (!variantId) return;

    const variantData = event.detail.dataset;
    if (!variantData) return;

    const stock = parseInt(variantData.stock ?? 0);
    const hasEverStock = variantData.hasEverStock === 'true';
    const isPreorder = variantData.isPreorder === 'true';
    const inventoryPolicy = variantData.inventoryPolicy ?? 'deny';
    const expectedSaleDate = variantData.expectedSaleDate;

    const allowPreorder = stock <= 0 && hasEverStock != true && isPreorder && inventoryPolicy === 'continue';

    this.updateContainers(stock, allowPreorder, expectedSaleDate);
  }  
  
  /**
   * @param {number} stock 
   * @param {boolean} allowPreorder 
   * @param {string} expectedSaleDate 
   */
  updateContainers(stock, allowPreorder, expectedSaleDate) {
    if (this.deliveryContainer) {
      this.deliveryContainer.style.display = stock > 0 ? 'block' : 'none';
    }

    if (this.preorderContainer) {
      this.preorderContainer.style.display = allowPreorder ? 'block' : 'none';
      
      if (allowPreorder && expectedSaleDate) {
        const dateSpan = this.preorderContainer.querySelector('#expected_sale_date');
        if (dateSpan) {
          const estimatedShippingDate = this.calculateShippingDate(expectedSaleDate);
          dateSpan.textContent = estimatedShippingDate;
        }
      }
    }
  }

  /**
   * @param {string} expectedSaleDate - Data di vendita attesa (formato YYYY-MM-DD)
   * @returns {string} - Data di spedizione formattata
   */
  calculateShippingDate(expectedSaleDate) {
    if (!expectedSaleDate) return '';
    
    const [year, month, day] = expectedSaleDate.split('-');
    const saleDate = new Date(year, parseInt(month) - 1, day);
    
    const shippingDate = this.addBusinessDays(saleDate, this.deliveryDays);
    
    return this.formatDate(shippingDate);
  }

  updateDeliveryDate() {
    if (!this.deliveryContainer) return;

    const today = new Date();
    const estimatedDate = this.addBusinessDays(today, this.deliveryDays);
    const formatted = this.formatDate(estimatedDate);

    const dateSpan = this.deliveryContainer.querySelector('#estimated-delivery-date');
    if (dateSpan) {
      dateSpan.innerText = formatted;
    }
  }

  /**
   * @param {Date} date - start date
   * @param {number} days - n day to add
   * @returns {Date} - new date
   */
  addBusinessDays(date, days) {
    const result = new Date(date);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();

      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  /**
   * @param {Date} date - Date to format
   * @returns {string} - Date formatted
   */
  formatDate(date) {
    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const day = date.getDate();

    return `${weekday} ${month} ${this.getOrdinal(day)}`;
  }

  /**
   * @param {number} n - Numero
   * @returns {string} - Numero con suffisso
   */
  getOrdinal(n) {
    if (n > 3 && n < 21) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PDPEstimatedDateManager();
});